
import TipsResult from './TipsResult'

export default TipsResult
